import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.authoring.datasets');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-authoring-datasets',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.authoring.datasets/view.scss */
:host {
  display: block;
}

.datasets-page {
  --ink: #17231f;
  --muted: #66756f;
  --line: #dce5e1;
  --soft: #f5f8f7;
  --brand: #137c57;
  --brand-dark: #0d6445;
  --brand-soft: #eaf6f1;
  color: var(--ink);
  font-size: 14px;
}

button,
input,
textarea,
select {
  font: inherit;
}

button,
a {
  -webkit-tap-highlight-color: transparent;
}

button:focus-visible,
a:focus-visible,
input:focus-visible,
textarea:focus-visible,
select:focus-visible {
  outline: 3px solid rgba(19, 124, 87, 0.2);
  outline-offset: 2px;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.page-heading {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 32px;
  margin-bottom: 24px;
}

.page-heading-copy {
  min-width: 0;
}

.page-kicker {
  display: block;
  margin-bottom: 8px;
  color: var(--brand);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.12em;
}

.page-heading h1 {
  margin: 0 0 9px;
  font-size: clamp(28px, 3vw, 36px);
  line-height: 1.15;
  letter-spacing: -0.045em;
}

.page-heading p {
  max-width: 700px;
  margin: 0;
  color: var(--muted);
  font-size: 15px;
  line-height: 1.65;
}

.page-actions,
.current-actions,
.dialog-footer {
  display: flex;
  align-items: center;
  gap: 9px;
}

.primary-action,
.secondary-action,
.quiet-link,
.next-link,
.save-button,
.remove-button {
  min-height: 40px;
  border-radius: 10px;
  padding: 9px 14px;
  font-weight: 750;
  text-decoration: none;
  cursor: pointer;
}

.primary-action,
.next-link,
.save-button {
  border: 1px solid var(--brand);
  background: var(--brand);
  color: #fff;
  box-shadow: 0 6px 16px rgba(19, 124, 87, 0.14);
}

.primary-action:hover,
.next-link:hover,
.save-button:hover {
  border-color: var(--brand-dark);
  background: var(--brand-dark);
}

.secondary-action,
.quiet-link {
  border: 1px solid #cfdbd6;
  background: #fff;
  color: #3f5149;
}

.secondary-action:hover,
.quiet-link:hover {
  border-color: #9fb6ac;
  background: #f9fbfa;
}

.button-link {
  font: inherit;
}

button:disabled {
  cursor: not-allowed;
  opacity: 0.52;
}

.purpose-flow {
  display: grid;
  grid-template-columns: 1fr 28px 1fr 28px 1fr;
  align-items: center;
  margin-bottom: 24px;
  padding: 17px 20px;
  border: 1px solid #e0e8e4;
  border-radius: 14px;
  background: #fff;
}

.purpose-flow article {
  display: flex;
  align-items: center;
  gap: 11px;
  min-width: 0;
}

.purpose-flow article > span {
  display: grid;
  place-items: center;
  flex: 0 0 30px;
  height: 30px;
  border-radius: 9px;
  background: var(--brand-soft);
  color: var(--brand);
  font-weight: 850;
}

.purpose-flow article > div {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 3px;
}

.purpose-flow article strong {
  font-size: 13px;
}

.purpose-flow article small {
  overflow: hidden;
  color: #74817c;
  font-size: 11px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.purpose-flow > i {
  position: relative;
  height: 1px;
  background: #dce5e1;
}

.purpose-flow > i::after {
  position: absolute;
  top: -3px;
  right: 0;
  width: 6px;
  height: 6px;
  border-top: 1px solid #aab9b3;
  border-right: 1px solid #aab9b3;
  transform: rotate(45deg);
  content: "";
}

.state-card {
  padding: 30px;
  border: 1px dashed #cbd8d2;
  border-radius: 15px;
  background: #fff;
  color: var(--muted);
  text-align: center;
}

.state-card.compact {
  padding: 22px;
}

.loading-state {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 11px;
}

.loading-spinner {
  width: 19px;
  height: 19px;
  border: 2px solid #cfe2da;
  border-top-color: var(--brand);
  border-radius: 50%;
  animation: dataset-spin 0.8s linear infinite;
}

@keyframes dataset-spin {
  to {
    transform: rotate(360deg);
  }
}
.current-dataset {
  display: grid;
  grid-template-columns: minmax(250px, 1.3fr) auto minmax(190px, auto);
  align-items: center;
  gap: 30px;
  margin-bottom: 30px;
  padding: 24px 26px;
  border: 1px solid #b8d8ca;
  border-radius: 18px;
  background: radial-gradient(circle at 94% 20%, rgba(56, 162, 120, 0.11), transparent 26%), linear-gradient(125deg, #f4fbf8 0%, #fff 70%);
  box-shadow: 0 12px 34px rgba(30, 76, 57, 0.07);
}

.current-copy {
  min-width: 0;
}

.current-label {
  display: flex;
  align-items: center;
  gap: 7px;
  color: var(--brand);
  font-size: 11px;
  font-weight: 800;
}

.current-label i {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #27a576;
  box-shadow: 0 0 0 4px rgba(39, 165, 118, 0.12);
}

.current-copy h2 {
  overflow: hidden;
  margin: 9px 0 6px;
  font-size: 24px;
  line-height: 1.25;
  letter-spacing: -0.035em;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.current-copy p {
  display: -webkit-box;
  overflow: hidden;
  margin: 0 0 8px;
  color: #586961;
  line-height: 1.5;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.current-copy > span {
  color: #819089;
  font-size: 11px;
}

.current-metrics {
  display: grid;
  grid-template-columns: repeat(3, minmax(76px, 1fr));
  align-self: stretch;
  border: 1px solid rgba(185, 210, 199, 0.72);
  border-radius: 13px;
  background: rgba(255, 255, 255, 0.76);
}

.current-metrics > div {
  display: flex;
  justify-content: center;
  min-width: 84px;
  flex-direction: column;
  padding: 14px 16px;
  text-align: center;
}

.current-metrics > div + div {
  border-left: 1px solid #e2eae6;
}

.current-metrics strong {
  font-size: 21px;
  font-variant-numeric: tabular-nums;
}

.current-metrics span {
  margin-top: 3px;
  color: #738079;
  font-size: 10px;
  white-space: nowrap;
}

.current-actions {
  justify-content: flex-end;
  flex-wrap: wrap;
}

.dataset-section {
  margin-bottom: 30px;
}

.section-heading {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 24px;
  margin-bottom: 14px;
}

.section-heading h2 {
  margin: 0 0 5px;
  font-size: 20px;
  letter-spacing: -0.025em;
}

.section-heading p {
  margin: 0;
  color: #718079;
  font-size: 12px;
}

.dataset-search,
.source-search {
  position: relative;
  display: block;
}

.dataset-search::before,
.source-search::before {
  position: absolute;
  top: 50%;
  left: 13px;
  width: 10px;
  height: 10px;
  border: 1.5px solid #75857e;
  border-radius: 50%;
  transform: translateY(-60%);
  content: "";
}

.dataset-search::after,
.source-search::after {
  position: absolute;
  top: 55%;
  left: 22px;
  width: 6px;
  height: 1.5px;
  background: #75857e;
  transform: rotate(45deg);
  content: "";
}

.dataset-search input,
.source-search input {
  width: min(320px, 40vw);
  min-height: 40px;
  border: 1px solid #d3ded9;
  border-radius: 10px;
  padding: 9px 12px 9px 35px;
  background: #fff;
  color: var(--ink);
}

.dataset-search input:focus,
.source-search input:focus {
  border-color: #83b6a1;
}

.empty-state {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.empty-state strong {
  color: #2c3c35;
  font-size: 17px;
}

.empty-state p {
  margin: 6px 0 15px;
}

.empty-icon {
  position: relative;
  width: 38px;
  height: 30px;
  margin-bottom: 13px;
  border-radius: 6px;
  background: #d7ae54;
}

.empty-icon::before {
  position: absolute;
  top: -6px;
  left: 3px;
  width: 16px;
  height: 8px;
  border-radius: 4px 4px 0 0;
  background: #d7ae54;
  content: "";
}

.dataset-list {
  overflow: hidden;
  border: 1px solid var(--line);
  border-radius: 15px;
  background: #fff;
}

.dataset-list article + article {
  border-top: 1px solid #e7ecea;
}

.dataset-list article.is-current {
  background: #f4faf7;
}

.dataset-select {
  display: grid;
  grid-template-columns: 38px minmax(230px, 1fr) 90px 86px minmax(150px, 0.55fr) 22px;
  align-items: center;
  gap: 14px;
  width: 100%;
  border: 0;
  padding: 16px 18px;
  background: transparent;
  color: inherit;
  text-align: left;
  cursor: pointer;
}

.dataset-select:hover {
  background: #f8faf9;
}

.dataset-mark {
  position: relative;
  width: 34px;
  height: 27px;
  border-radius: 6px;
  background: #d9b057;
}

.dataset-mark::before {
  position: absolute;
  top: -5px;
  left: 3px;
  width: 14px;
  height: 7px;
  border-radius: 4px 4px 0 0;
  background: #d9b057;
  content: "";
}

.is-current .dataset-mark,
.is-current .dataset-mark::before {
  background: #42a37d;
}

.dataset-main {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 5px;
}

.dataset-title-row {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.dataset-title-row strong {
  overflow: hidden;
  font-size: 15px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-title-row em {
  flex: 0 0 auto;
  padding: 3px 7px;
  border-radius: 99px;
  background: #e4f3ec;
  color: var(--brand);
  font-size: 9px;
  font-style: normal;
  font-weight: 800;
}

.dataset-main > small {
  overflow: hidden;
  color: #74827c;
  font-size: 11px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-source-count,
.dataset-scope {
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  gap: 2px;
}

.dataset-source-count strong,
.dataset-scope strong {
  font-size: 15px;
  font-variant-numeric: tabular-nums;
}

.dataset-source-count small,
.dataset-scope small {
  color: #819089;
  font-size: 9px;
}

.dataset-role {
  overflow: hidden;
  color: #65756e;
  font-size: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-arrow {
  color: #7c8c85;
  font-size: 24px;
  line-height: 1;
}

.member-panel {
  padding: 22px;
  border: 1px solid var(--line);
  border-radius: 16px;
  background: #fff;
}

.member-heading {
  align-items: center;
}

.member-list {
  display: grid;
  gap: 10px;
}

.member-list article {
  display: grid;
  grid-template-columns: minmax(230px, 1fr) minmax(340px, 1.8fr) auto;
  align-items: center;
  gap: 18px;
  padding: 15px;
  border: 1px solid #e4ebe7;
  border-radius: 13px;
}

.identity {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.avatar {
  display: grid;
  place-items: center;
  flex: 0 0 36px;
  height: 36px;
  border-radius: 10px;
  background: #e9f5f0;
  color: #147653;
  font-weight: 800;
}

.identity div {
  display: flex;
  min-width: 0;
  flex-direction: column;
}

.identity small {
  overflow: hidden;
  color: #77847f;
  text-overflow: ellipsis;
}

.identity > em {
  margin-left: auto;
  padding: 4px 7px;
  border-radius: 99px;
  background: #f1f3f2;
  color: #81908a;
  font-size: 10px;
  font-style: normal;
}

.identity > em.active {
  background: #e7f6ef;
  color: #17815c;
}

.role-options {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.role-options button {
  display: flex;
  align-items: center;
  gap: 5px;
  border: 1px solid #d9e2de;
  border-radius: 8px;
  padding: 7px 9px;
  background: #fff;
  color: #66756f;
  font-size: 11px;
}

.role-options button i {
  width: 7px;
  height: 7px;
  border: 1px solid #aab7b1;
  border-radius: 2px;
}

.role-options button.selected {
  border-color: #76bda3;
  background: #eef8f4;
  color: #176d50;
}

.role-options button.selected i {
  border-color: #1a8f65;
  background: #1a8f65;
}

.member-actions {
  display: flex;
  gap: 7px;
}

.member-actions button {
  white-space: nowrap;
}

.remove-button {
  border: 1px solid #ead6d4;
  background: #fff;
  color: #a74d43;
}

.dataset-drive {
  max-width: 1540px;
  min-height: 100vh;
  box-sizing: border-box;
  margin: 0 auto;
  padding: 24px 28px 36px;
}

.drive-shell {
  min-height: 620px;
  display: grid;
  overflow: hidden;
  border: 1px solid #dfe6e3;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(30, 50, 43, 0.03);
  grid-template-columns: minmax(0, 1fr);
}

.drive-panel {
  position: relative;
  min-width: 0;
  min-height: inherit;
  display: flex;
  flex-direction: column;
  background: #fff;
}

.drive-loading-bar {
  position: absolute;
  z-index: 5;
  top: 0;
  right: 0;
  left: 0;
  height: 3px;
  overflow: hidden;
  background: #dceae5;
}

.drive-loading-bar i {
  position: absolute;
  width: 34%;
  height: 100%;
  background: #248765;
  animation: dataset-drive-loading 1s ease-in-out infinite;
}

@keyframes dataset-drive-loading {
  from {
    transform: translateX(-110%);
  }
  to {
    transform: translateX(300%);
  }
}
.drive-page-header {
  position: relative;
  z-index: 4;
  border-bottom: 1px solid #e7ecea;
  background: #fff;
}

.drive-navigation-bar {
  min-width: 0;
  min-height: 70px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 0 22px;
  border-bottom: 1px solid #edf1ef;
  gap: 22px;
}

.breadcrumbs {
  min-width: 0;
  display: flex;
  flex: 1 1 auto;
  align-items: center;
}

.breadcrumbs button {
  overflow: hidden;
  padding: 6px 7px;
  border: 0;
  border-radius: 6px;
  color: #172f27;
  background: transparent;
  font-size: 14px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.navigation-tools {
  min-width: 0;
  display: flex;
  flex: 0 1 650px;
  align-items: center;
  justify-content: flex-end;
}

.drive-search {
  min-width: 240px;
  max-width: 540px;
  height: 42px;
  display: flex;
  flex: 1 1 360px;
  align-items: center;
  box-sizing: border-box;
  padding: 0 14px;
  border: 1px solid transparent;
  border-radius: 10px;
  background: #f1f4f3;
  transition: background 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
  gap: 11px;
}

.drive-search:focus-within {
  border-color: #c9d7d2;
  background: #fff;
  box-shadow: 0 2px 8px rgba(33, 58, 49, 0.09);
}

.drive-search > svg {
  width: 19px;
  height: 19px;
  flex: 0 0 auto;
  fill: none;
  stroke: #61736c;
  stroke-linecap: round;
  stroke-width: 1.8;
}

.drive-search input {
  min-width: 0;
  flex: 1;
  border: 0;
  outline: 0;
  color: #263b34;
  background: transparent;
  font-size: 13px;
}

.drive-search input::placeholder {
  color: #75857f;
}

.drive-search > button {
  width: 28px;
  height: 28px;
  display: grid;
  flex: 0 0 auto;
  padding: 0;
  border: 0;
  border-radius: 50%;
  place-items: center;
  color: #6e7d78;
  background: transparent;
  font-size: 18px;
}

.drive-search > button:hover {
  background: #e7ecea;
}

.drive-command-bar {
  min-height: 56px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 8px 22px;
  background: #fbfcfc;
  gap: 16px;
}

.dataset-workflow {
  min-width: 0;
  display: flex;
  align-items: center;
  overflow-x: auto;
  color: #53665e;
  font-size: 12px;
  font-weight: 700;
  gap: 8px;
}

.dataset-workflow span {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  gap: 6px;
}

.dataset-workflow i {
  width: 22px;
  height: 22px;
  display: grid;
  border-radius: 7px;
  place-items: center;
  color: #176d54;
  background: #e7f3ee;
  font-size: 10px;
  font-style: normal;
}

.dataset-workflow > svg {
  width: 14px;
  height: 14px;
  flex: 0 0 auto;
  fill: none;
  stroke: #a3afaa;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.8;
}

.list-utilities {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 5px;
}

.location-count {
  margin-right: 3px;
  color: #697a73;
  font-size: 11px;
  white-space: nowrap;
}

.command-icon-button {
  width: 38px;
  height: 38px;
  position: relative;
  display: grid;
  flex: 0 0 auto;
  box-sizing: border-box;
  padding: 0;
  border: 1px solid transparent;
  border-radius: 10px;
  place-items: center;
  color: #50645c;
  background: transparent;
  cursor: pointer;
  transition: color 0.15s ease, background 0.15s ease, transform 0.15s ease;
}

.command-icon-button:hover {
  color: #126149;
  background: #e9f0ed;
}

.command-icon-button svg {
  width: 19px;
  height: 19px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.8;
}

.command-icon-button[data-tooltip]::before,
.command-icon-button[data-tooltip]::after {
  position: absolute;
  left: 50%;
  z-index: 24;
  opacity: 0;
  pointer-events: none;
  visibility: hidden;
  transition: opacity 0.14s ease, transform 0.14s ease, visibility 0.14s ease;
}

.command-icon-button[data-tooltip]::before {
  bottom: calc(100% + 4px);
  border-width: 5px 5px 0;
  border-style: solid;
  border-color: #263b34 transparent transparent;
  content: "";
  transform: translate(-50%, 3px);
}

.command-icon-button[data-tooltip]::after {
  bottom: calc(100% + 9px);
  padding: 6px 8px;
  border-radius: 6px;
  color: #fff;
  background: #263b34;
  box-shadow: 0 4px 12px rgba(25, 48, 40, 0.18);
  content: attr(data-tooltip);
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
  transform: translate(-50%, 3px);
}

.command-icon-button[data-tooltip]:hover::before,
.command-icon-button[data-tooltip]:hover::after,
.command-icon-button[data-tooltip]:focus-visible::before,
.command-icon-button[data-tooltip]:focus-visible::after {
  opacity: 1;
  visibility: visible;
  transform: translate(-50%, 0);
}

.create-action-wrap {
  flex: 0 0 auto;
  margin-left: 3px;
  padding-left: 10px;
  border-left: 1px solid #dfe6e3;
}

.create-primary {
  width: 40px;
  height: 40px;
  border: 0;
  border-radius: 11px;
  color: #fff;
  background: #176d54;
  box-shadow: 0 1px 2px rgba(18, 73, 56, 0.18);
}

.create-primary:hover {
  color: #fff;
  background: #105f49;
  transform: translateY(-1px);
}

.drive-content {
  min-height: 380px;
  flex: 1;
  box-sizing: border-box;
  padding: 22px;
}

.dataset-loading-state {
  min-height: 360px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #667770;
  gap: 14px;
}

.dataset-loading-state > div {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.dataset-loading-state strong {
  color: #34483f;
  font-size: 13px;
}

.dataset-loading-state div span {
  font-size: 11px;
}

.active-dataset-strip {
  display: grid;
  align-items: center;
  margin-bottom: 18px;
  padding: 15px 17px;
  border: 1px solid #cfe1da;
  border-radius: 11px;
  background: #f3f8f6;
  grid-template-columns: minmax(240px, 1fr) auto auto;
  gap: 22px;
}

.active-dataset-copy {
  min-width: 0;
}

.active-label {
  display: flex;
  align-items: center;
  color: #176d54;
  font-size: 10px;
  font-weight: 800;
  gap: 6px;
}

.active-label i {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #26936f;
  box-shadow: 0 0 0 3px rgba(38, 147, 111, 0.12);
}

.active-dataset-copy h2 {
  overflow: hidden;
  margin: 5px 0 3px;
  color: #233b33;
  font-size: 16px;
  letter-spacing: -0.02em;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.active-dataset-copy p {
  overflow: hidden;
  margin: 0 0 3px;
  color: #60716a;
  font-size: 11px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.active-dataset-copy small {
  color: #82908a;
  font-size: 10px;
}

.active-metrics {
  display: flex;
  align-items: stretch;
  border: 1px solid #d8e5e0;
  border-radius: 9px;
  background: rgba(255, 255, 255, 0.78);
}

.active-metrics > span {
  min-width: 70px;
  display: flex;
  flex-direction: column;
  padding: 8px 10px;
  text-align: center;
  gap: 1px;
}

.active-metrics > span + span {
  border-left: 1px solid #e2eae7;
}

.active-metrics strong {
  color: #29463b;
  font-size: 14px;
  font-variant-numeric: tabular-nums;
}

.active-metrics small {
  color: #7a8983;
  font-size: 9px;
  white-space: nowrap;
}

.active-actions {
  display: flex;
  align-items: center;
  gap: 6px;
}

.compact-action {
  min-height: 32px;
  display: inline-flex;
  align-items: center;
  box-sizing: border-box;
  padding: 0 10px;
  border: 1px solid #ccd9d4;
  border-radius: 8px;
  color: #455b52;
  background: #fff;
  cursor: pointer;
  font-size: 11px;
  font-weight: 750;
  text-decoration: none;
  white-space: nowrap;
}

.compact-action:hover {
  border-color: #9eb7ad;
  background: #f9fbfa;
}

.compact-action.primary {
  border-color: #176d54;
  color: #fff;
  background: #176d54;
}

.dataset-section {
  margin-bottom: 0;
}

.list-section-label {
  display: flex;
  align-items: flex-end;
  margin-bottom: 10px;
}

.list-section-label h2 {
  margin: 0 0 3px;
  color: #2c4038;
  font-size: 14px;
  letter-spacing: -0.01em;
}

.list-section-label p {
  margin: 0;
  color: #75847e;
  font-size: 10px;
}

.drive-list {
  overflow: hidden;
  border: 1px solid #e0e7e4;
  border-radius: 11px;
  background: #fff;
}

.dataset-drive-list {
  width: 100%;
  box-sizing: border-box;
}

.drive-head,
.drive-row {
  width: 100%;
  display: grid;
  align-items: center;
  box-sizing: border-box;
  padding: 0 14px;
  grid-template-columns: minmax(260px, 1.7fr) 96px 112px minmax(130px, 0.7fr) 88px 24px;
  gap: 12px;
}

.drive-head {
  min-height: 42px;
  border-bottom: 1px solid #e2e8e5;
  color: #61736b;
  background: #fafbfb;
  font-size: 12px;
  font-weight: 700;
}

.sort-button {
  min-width: 0;
  min-height: 30px;
  display: inline-flex;
  align-items: center;
  padding: 0;
  border: 0;
  color: inherit;
  background: transparent;
  cursor: pointer;
  font: inherit;
  gap: 4px;
}

.sort-button:hover,
.sort-button.active {
  color: #326e59;
}

.sort-button svg {
  width: 14px;
  height: 14px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.8;
  opacity: 0.45;
}

.sort-button.active svg {
  opacity: 1;
}

.sort-button.active:not(.desc) .sort-down,
.sort-button.active.desc .sort-up {
  opacity: 0;
}

.drive-row {
  min-height: 64px;
  border: 0;
  border-bottom: 1px solid #edf1ef;
  color: #4f625a;
  background: #fff;
  cursor: pointer;
  font-size: 12px;
  text-align: left;
}

.drive-row:last-child {
  border-bottom: 0;
}

.drive-row:hover {
  background: #f5f8f7;
}

.drive-row.is-selected {
  background: #edf5f2;
  box-shadow: inset 3px 0 #3d8c70;
}

.drive-row.is-selected .dataset-mark,
.drive-row.is-selected .dataset-mark::before {
  background: #42a37d;
}

.dataset-name-cell {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 12px;
}

.dataset-name-cell .dataset-mark {
  flex: 0 0 34px;
}

.dataset-main strong {
  overflow: hidden;
  color: #2b4038;
  font-size: 13px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-main small {
  overflow: hidden;
  color: #75847e;
  font-size: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.numeric-cell {
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.numeric-cell strong {
  color: #3a5148;
  font-size: 13px;
  font-variant-numeric: tabular-nums;
}

.numeric-cell small {
  color: #84918c;
  font-size: 9px;
}

.dataset-role {
  color: #5e7068;
  font-size: 11px;
}

.dataset-status {
  display: inline-flex;
  align-items: center;
  color: #687a72;
  font-size: 10px;
  font-weight: 700;
  gap: 6px;
}

.dataset-status i {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #a5b2ad;
}

.dataset-status.current {
  color: #176d54;
}

.dataset-status.current i {
  background: #26936f;
  box-shadow: 0 0 0 3px rgba(38, 147, 111, 0.12);
}

.dataset-arrow {
  display: grid;
  place-items: center;
}

.dataset-arrow svg {
  width: 17px;
  height: 17px;
  fill: none;
  stroke: #84938d;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.8;
}

.drive-pagination {
  min-height: 52px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 4px;
  color: #6e7e78;
  font-size: 11px;
}

.pagination-controls {
  display: flex;
  align-items: center;
  gap: 9px;
}

.pagination-controls button {
  width: 30px;
  height: 30px;
  display: grid;
  padding: 0;
  border: 1px solid #d2dcd8;
  border-radius: 8px;
  place-items: center;
  color: #506159;
  background: #fff;
  cursor: pointer;
  font-size: 18px;
}

.pagination-controls button:disabled {
  cursor: default;
  opacity: 0.38;
}

.member-panel {
  margin-top: 22px;
}

.dialog-backdrop {
  position: fixed;
  z-index: 1200;
  inset: 0;
  display: grid;
  place-items: center;
  padding: 24px;
  background: rgba(13, 25, 20, 0.48);
  backdrop-filter: blur(3px);
}

.create-dialog {
  display: flex;
  overflow: hidden;
  width: min(940px, 100%);
  max-height: min(860px, 100vh - 48px);
  flex-direction: column;
  border: 1px solid rgba(214, 227, 221, 0.9);
  border-radius: 20px;
  background: #fff;
  box-shadow: 0 28px 80px rgba(5, 25, 16, 0.28);
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 21px 24px 16px;
  border-bottom: 1px solid #e3eae7;
}

.dialog-header > div {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.dialog-header span {
  color: var(--brand);
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.08em;
}

.dialog-header h2 {
  margin: 0;
  font-size: 23px;
  letter-spacing: -0.035em;
}

.dialog-close {
  display: grid;
  place-items: center;
  width: 38px;
  height: 38px;
  border: 1px solid #d7e0dc;
  border-radius: 10px;
  background: #fff;
  color: #53635c;
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
}

.dialog-steps {
  display: grid;
  grid-template-columns: 1fr 72px 1fr;
  align-items: center;
  padding: 14px 24px;
  border-bottom: 1px solid #e8edeb;
  background: #fafcfb;
}

.dialog-steps button {
  display: flex;
  align-items: center;
  gap: 9px;
  border: 0;
  padding: 0;
  background: transparent;
  color: #87948e;
  text-align: left;
}

.dialog-steps button:last-child {
  justify-content: flex-end;
}

.dialog-steps button > span {
  display: grid;
  place-items: center;
  width: 26px;
  height: 26px;
  border: 1px solid #ccd8d2;
  border-radius: 8px;
  background: #fff;
  font-size: 11px;
}

.dialog-steps button.active,
.dialog-steps button.done {
  color: var(--brand);
}

.dialog-steps button.active > span,
.dialog-steps button.done > span {
  border-color: var(--brand);
  background: var(--brand);
  color: #fff;
}

.dialog-steps > i {
  height: 1px;
  background: #d9e2de;
}

.dialog-body {
  overflow-y: auto;
  min-height: 0;
  padding: 24px;
}

.basic-step {
  display: grid;
  grid-template-columns: minmax(230px, 0.75fr) minmax(320px, 1.25fr);
  align-items: start;
  gap: 28px 36px;
}

.step-intro strong {
  display: block;
  max-width: 280px;
  margin-bottom: 9px;
  font-size: 20px;
  line-height: 1.4;
  letter-spacing: -0.025em;
}

.step-intro p {
  max-width: 290px;
  margin: 0;
  color: #6e7c76;
  line-height: 1.65;
}

.create-fields {
  display: grid;
  gap: 16px;
}

.create-fields label {
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.create-fields label > span {
  color: #405149;
  font-size: 12px;
  font-weight: 750;
}

.create-fields label em {
  margin-left: 3px;
  color: var(--brand);
  font-size: 9px;
  font-style: normal;
}

.create-fields input,
.create-fields textarea,
.create-fields select {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #cfdad5;
  border-radius: 10px;
  padding: 11px 12px;
  background: #fff;
  color: var(--ink);
  resize: vertical;
}

.snapshot-guide {
  grid-column: 1/-1;
  display: flex;
  align-items: flex-start;
  gap: 11px;
  padding: 14px 16px;
  border-radius: 12px;
  background: #f2f7f5;
}

.snapshot-guide > i {
  display: grid;
  place-items: center;
  flex: 0 0 22px;
  height: 22px;
  border-radius: 50%;
  background: #d9eee5;
  color: var(--brand);
  font-size: 11px;
  font-style: normal;
  font-weight: 800;
}

.snapshot-guide > div {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.snapshot-guide span {
  color: #687770;
  font-size: 11px;
  line-height: 1.5;
}

.source-step {
  padding-top: 18px;
}

.source-step-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  margin-bottom: 15px;
}

.source-step-toolbar > div:first-child {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.source-step-toolbar > div:first-child span {
  color: #738079;
  font-size: 11px;
}

.selection-summary {
  display: flex;
  align-items: baseline;
  gap: 5px;
  padding: 8px 12px;
  border-radius: 10px;
  background: var(--brand-soft);
  color: var(--brand);
}

.selection-summary strong {
  font-size: 18px;
  font-variant-numeric: tabular-nums;
}

.selection-summary span {
  font-size: 10px;
  font-weight: 700;
}

.selection-summary em {
  margin-left: 5px;
  color: #ad5147;
  font-size: 9px;
  font-style: normal;
}

.source-controls {
  display: grid;
  grid-template-columns: auto minmax(220px, 1fr) auto;
  gap: 9px;
  margin-bottom: 12px;
}

.source-tabs {
  display: flex;
  padding: 3px;
  border: 1px solid #d5dfda;
  border-radius: 10px;
  background: #f4f7f5;
}

.source-tabs button {
  border: 0;
  border-radius: 7px;
  padding: 7px 12px;
  background: transparent;
  color: #687770;
  font-size: 11px;
  font-weight: 750;
}

.source-tabs button.active {
  background: #fff;
  color: var(--brand);
  box-shadow: 0 2px 6px rgba(27, 66, 50, 0.08);
}

.source-search input {
  width: 100%;
}

.clear-selection {
  border: 0;
  background: transparent;
  color: #687770;
  font-size: 11px;
  text-decoration: underline;
  cursor: pointer;
}

.source-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 260px;
  flex-direction: column;
  gap: 7px;
  border: 1px dashed #d6dfdb;
  border-radius: 12px;
  color: #53635c;
}

.source-loading .loading-spinner {
  margin-bottom: 4px;
}

.source-loading small {
  color: #84918b;
}

.source-result-list {
  display: grid;
  overflow: hidden;
  border: 1px solid #dbe4e0;
  border-radius: 12px;
}

.source-result-list > button {
  display: grid;
  grid-template-columns: 36px minmax(0, 1fr) 70px 18px;
  align-items: center;
  gap: 11px;
  min-height: 56px;
  border: 0;
  padding: 9px 13px;
  background: #fff;
  color: #3d4e47;
  text-align: left;
  cursor: pointer;
}

.source-result-list > button + button {
  border-top: 1px solid #e7ece9;
}

.source-result-list > button:hover {
  background: #f8fbfa;
}

.source-result-list > button.selected {
  background: #eef8f4;
}

.source-result-list > button.not-ready {
  background: #fbfaf8;
}

.folder-shape {
  position: relative;
  width: 30px;
  height: 21px;
  border-radius: 5px;
  background: #d8aa48;
}

.folder-shape::before {
  position: absolute;
  top: -5px;
  left: 3px;
  width: 13px;
  height: 7px;
  border-radius: 4px 4px 0 0;
  background: inherit;
  content: "";
}

.document-shape {
  display: grid;
  place-items: center;
  width: 27px;
  height: 32px;
  border: 1px solid #bdd3c9;
  border-radius: 5px;
  background: #eff7f3;
  color: var(--brand);
  font-size: 7px;
  font-weight: 850;
}

.result-copy {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 3px;
}

.result-copy strong,
.result-copy small {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.result-copy strong {
  font-size: 12px;
}

.result-copy small {
  color: #7b8983;
  font-size: 10px;
}

.result-status {
  color: #9a655b;
  font-size: 9px;
  font-weight: 750;
  text-align: right;
}

.result-status.ready {
  color: var(--brand);
}

.source-result-list > button > i {
  width: 13px;
  height: 13px;
  border: 1px solid #aab7b1;
  border-radius: 4px;
}

.source-result-list > button.selected > i {
  border-color: var(--brand);
  background: var(--brand);
  box-shadow: inset 0 0 0 2px #eef8f4;
}

.source-pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  color: #78857f;
  font-size: 10px;
}

.source-pagination > div {
  display: flex;
  align-items: center;
  gap: 9px;
}

.source-pagination button {
  display: grid;
  place-items: center;
  width: 30px;
  height: 30px;
  border: 1px solid #d2dcd8;
  border-radius: 8px;
  background: #fff;
  color: #506159;
  font-size: 18px;
}

.snapshot-note {
  display: block;
  margin-top: 12px;
  color: #7b8882;
  font-size: 10px;
  line-height: 1.5;
}

.dialog-footer {
  justify-content: flex-end;
  padding: 14px 24px;
  border-top: 1px solid #e3eae7;
  background: #fafcfb;
}

@media (max-width: 1180px) {
  .current-dataset {
    grid-template-columns: 1fr auto;
  }
  .current-actions {
    grid-column: 1/-1;
    justify-content: flex-start;
  }
  .dataset-select {
    grid-template-columns: 38px minmax(220px, 1fr) 80px 80px 22px;
  }
  .dataset-select .dataset-role {
    display: none;
  }
  .member-list article {
    grid-template-columns: 1fr;
  }
  .member-actions {
    justify-content: flex-end;
  }
}
@media (max-width: 800px) {
  .page-heading,
  .section-heading,
  .source-step-toolbar {
    align-items: stretch;
    flex-direction: column;
  }
  .page-actions {
    justify-content: flex-end;
  }
  .purpose-flow {
    grid-template-columns: 1fr;
    gap: 9px;
  }
  .purpose-flow > i {
    display: none;
  }
  .purpose-flow article small {
    white-space: normal;
  }
  .current-dataset {
    grid-template-columns: 1fr;
    gap: 18px;
  }
  .current-actions {
    grid-column: auto;
  }
  .dataset-search input {
    width: 100%;
  }
  .dataset-select {
    grid-template-columns: 34px minmax(0, 1fr) 62px 20px;
    gap: 10px;
    padding: 14px;
  }
  .dataset-select .dataset-scope,
  .dataset-select .dataset-role {
    display: none;
  }
  .basic-step {
    grid-template-columns: 1fr;
    gap: 18px;
  }
  .snapshot-guide {
    grid-column: auto;
  }
  .source-controls {
    grid-template-columns: 1fr;
  }
  .source-tabs {
    justify-content: stretch;
  }
  .source-tabs button {
    flex: 1;
  }
}
@media (max-width: 560px) {
  .page-heading h1 {
    font-size: 28px;
  }
  .page-actions,
  .current-actions,
  .dialog-footer {
    align-items: stretch;
    flex-direction: column;
  }
  .page-actions > *,
  .current-actions > *,
  .dialog-footer > * {
    justify-content: center;
    width: 100%;
    box-sizing: border-box;
    text-align: center;
  }
  .current-metrics {
    grid-template-columns: 1fr;
  }
  .current-metrics > div + div {
    border-top: 1px solid #e2eae6;
    border-left: 0;
  }
  .dataset-source-count {
    display: none;
  }
  .dataset-select {
    grid-template-columns: 32px minmax(0, 1fr) 20px;
  }
  .dialog-backdrop {
    align-items: end;
    padding: 0;
  }
  .create-dialog {
    max-height: 94vh;
    border-radius: 18px 18px 0 0;
  }
  .dialog-header,
  .dialog-body,
  .dialog-footer {
    padding-right: 17px;
    padding-left: 17px;
  }
  .dialog-steps {
    grid-template-columns: 1fr 24px 1fr;
    padding-right: 17px;
    padding-left: 17px;
  }
  .dialog-steps button strong {
    font-size: 10px;
  }
  .source-result-list > button {
    grid-template-columns: 31px minmax(0, 1fr) 16px;
  }
  .result-status {
    display: none;
  }
  .selection-summary {
    align-self: flex-start;
  }
}
@media (max-width: 1080px) {
  .active-dataset-strip {
    grid-template-columns: minmax(220px, 1fr) auto;
  }
  .active-actions {
    grid-column: 1/-1;
    justify-content: flex-end;
  }
  .drive-head,
  .drive-row {
    grid-template-columns: minmax(230px, 1.6fr) 88px 100px minmax(120px, 0.65fr) 82px 20px;
    gap: 9px;
  }
}
@media (max-width: 800px) {
  .dataset-drive {
    padding: 14px;
  }
  .drive-navigation-bar {
    min-height: auto;
    align-items: stretch;
    flex-direction: column;
    padding: 14px;
    gap: 10px;
  }
  .navigation-tools {
    flex: auto;
  }
  .drive-search {
    min-width: 0;
    max-width: none;
  }
  .drive-command-bar {
    align-items: stretch;
    flex-direction: column;
    padding: 10px 14px;
  }
  .list-utilities {
    justify-content: flex-end;
  }
  .drive-content {
    padding: 14px;
  }
  .active-dataset-strip {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  .active-metrics {
    justify-self: stretch;
  }
  .active-metrics > span {
    flex: 1;
  }
  .active-actions {
    grid-column: auto;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .drive-head,
  .drive-row {
    grid-template-columns: minmax(210px, 1fr) 82px 80px 20px;
  }
  .drive-head > span:nth-child(4),
  .drive-head > span:nth-child(5),
  .dataset-drive-row > .dataset-role,
  .dataset-drive-row > .dataset-status {
    display: none;
  }
}
@media (max-width: 560px) {
  .dataset-drive {
    padding: 8px;
  }
  .drive-shell {
    min-height: calc(100vh - 16px);
    border-radius: 12px;
  }
  .dataset-workflow {
    width: 100%;
  }
  .location-count {
    margin-right: auto;
  }
  .drive-content {
    padding: 10px;
  }
  .active-metrics > span {
    min-width: 0;
    padding: 8px 5px;
  }
  .compact-action {
    flex: 1;
    justify-content: center;
  }
  .list-section-label p {
    line-height: 1.5;
  }
  .drive-head,
  .drive-row {
    grid-template-columns: minmax(0, 1fr) 68px 18px;
    padding: 0 10px;
  }
  .drive-head > span:nth-child(3),
  .dataset-drive-row > .numeric-cell:nth-child(3) {
    display: none;
  }
  .dataset-name-cell {
    gap: 9px;
  }
  .dataset-name-cell .dataset-mark {
    flex-basis: 30px;
    width: 30px;
  }
}`],
})
export class PageAuthoringDatasetsComponent implements OnInit {
    public loading: boolean = true;
    public datasets: any[] = [];
    public accounts: any[] = [];
    public sourceOrganizations: any[] = [];
    public sourceFolders: any[] = [];
    public sourceAssets: any[] = [];
    public sourceFolderResults: any[] = [];
    public sourceAssetResults: any[] = [];
    public sourceLoading: boolean = false;
    public selectedId: string = '';
    public datasetQuery: string = '';
    public datasetPage: number = 1;
    public datasetPageSize: number = 10;
    public datasetSortField: string = 'name';
    public datasetSortDirection: string = 'asc';
    public showCreateDialog: boolean = false;
    public showMemberPanel: boolean = false;
    public createStep: number = 1;
    public sourceMode: string = 'FOLDER';
    public sourceQuery: string = '';
    public sourcePage: number = 1;
    public sourcePageSize: number = 20;
    public selectedDocumentTotal: number = 0;
    public selectedUnavailableTotal: number = 0;
    public folderById: any = {};
    public catalogOrganizationId: string = '';
    public newDataset: any = this.emptyDataset();
    public creating: boolean = false;

    public researcherRoles: any[] = [
        { value: 'DATASET_ADMIN', label: '데이터셋 관리자' },
        { value: 'AUTHOR', label: '저작자' },
        { value: 'GENERATION_OPERATOR', label: 'QA 생성 운영자' },
        { value: 'REVIEW_ADMIN', label: '검수 관리자' },
        { value: 'ADJUDICATOR', label: '이견조정자' },
        { value: 'REVIEWER', label: '내부 검수자' },
        { value: 'RELEASE_ADMIN', label: '릴리스 관리자' }
    ];

    public reviewerRoles: any[] = [
        { value: 'REVIEWER', label: '한의사 검수자' }
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.loadDatasets();
    }

    private emptyDataset(organizationId: string = '') {
        return {
            name: '',
            description: '',
            organization_id: organizationId,
            source_folder_ids: [],
            source_asset_ids: []
        };
    }

    public isSystemAdmin() {
        return this.service.auth.session.user_type === 'SYSTEM_ADMIN';
    }

    public selectedDataset() {
        return this.datasets.find((dataset: any) => dataset.id === this.selectedId);
    }

    public filteredDatasets() {
        let query = this.normalizeSearch(this.datasetQuery);
        let filtered = this.datasets.filter((dataset: any) => {
            if (!query) return true;
            return this.normalizeSearch([
                dataset.name,
                dataset.description,
                dataset.organization_name
            ].join(' ')).indexOf(query) >= 0;
        });
        return filtered.slice().sort((left: any, right: any) => {
            let leftValue = this.datasetSortValue(left, this.datasetSortField);
            let rightValue = this.datasetSortValue(right, this.datasetSortField);
            let compared = typeof leftValue === 'number'
                ? leftValue - rightValue
                : String(leftValue).localeCompare(String(rightValue), 'ko');
            if (!compared) {
                compared = this.normalizeSearch(left.name).localeCompare(
                    this.normalizeSearch(right.name),
                    'ko'
                );
            }
            return this.datasetSortDirection === 'desc' ? -compared : compared;
        });
    }

    private datasetSortValue(dataset: any, field: string): any {
        if (field === 'source') return Number(dataset.source_version_count || 0);
        if (field === 'scope') {
            return Number(dataset.source_folder_count || 0) + Number(dataset.source_asset_count || 0);
        }
        return this.normalizeSearch(dataset.name);
    }

    public updateDatasetSearch() {
        this.datasetPage = 1;
    }

    public clearDatasetSearch() {
        this.datasetQuery = '';
        this.datasetPage = 1;
    }

    public changeDatasetSort(field: string) {
        if (this.datasetSortField === field) {
            this.datasetSortDirection = this.datasetSortDirection === 'asc' ? 'desc' : 'asc';
        } else {
            this.datasetSortField = field;
            this.datasetSortDirection = 'asc';
        }
        this.datasetPage = 1;
    }

    public datasetSortAriaSort(field: string) {
        if (this.datasetSortField !== field) return 'none';
        return this.datasetSortDirection === 'asc' ? 'ascending' : 'descending';
    }

    public datasetSortAriaLabel(field: string, label: string) {
        if (this.datasetSortField !== field) return label + ' 오름차순 정렬';
        return label + (this.datasetSortDirection === 'asc' ? ' 내림차순 정렬' : ' 오름차순 정렬');
    }

    public visibleDatasets() {
        let start = (this.datasetPage - 1) * this.datasetPageSize;
        return this.filteredDatasets().slice(start, start + this.datasetPageSize);
    }

    public datasetPageCount() {
        return Math.max(1, Math.ceil(this.filteredDatasets().length / this.datasetPageSize));
    }

    public datasetPageStart() {
        return this.filteredDatasets().length
            ? (this.datasetPage - 1) * this.datasetPageSize + 1
            : 0;
    }

    public datasetPageEnd() {
        return Math.min(this.datasetPage * this.datasetPageSize, this.filteredDatasets().length);
    }

    public changeDatasetPage(direction: number) {
        this.datasetPage = Math.max(
            1,
            Math.min(this.datasetPageCount(), this.datasetPage + direction)
        );
    }

    public canManage() {
        let dataset = this.selectedDataset();
        return this.isSystemAdmin() || !!(
            dataset && (dataset.roles || []).indexOf('DATASET_ADMIN') >= 0
        );
    }

    public roleSummary(dataset: any) {
        let labels: any = {
            DATASET_ADMIN: '관리자',
            AUTHOR: '저작자',
            GENERATION_OPERATOR: '생성 운영자',
            REVIEW_ADMIN: '검수 관리자',
            ADJUDICATOR: '이견 조정자',
            REVIEWER: '검수자',
            RELEASE_ADMIN: '배포 관리자'
        };
        let roles = (dataset.roles || []).map((role: string) => labels[role] || role);
        return roles.length > 2
            ? roles.slice(0, 2).join(' · ') + ' 외 ' + (roles.length - 2) + '개'
            : (roles.join(' · ') || '조회 권한');
    }

    public rolesFor(account: any) {
        return account.user_type === 'MEDICAL_REVIEWER'
            ? this.reviewerRoles
            : this.researcherRoles;
    }

    public hasRole(account: any, role: string) {
        return (account.roles || []).indexOf(role) >= 0;
    }

    public toggleRole(account: any, role: string) {
        let roles = account.roles || [];
        let index = roles.indexOf(role);
        if (index >= 0) roles.splice(index, 1);
        else roles.push(role);
        account.roles = roles;
    }

    private normalizeSearch(value: any) {
        return String(value || '').trim().toLocaleLowerCase();
    }

    private async showError(message: string) {
        await this.service.modal.show({
            title: '처리 실패',
            message: message,
            cancel: false,
            action: '확인',
            actionBtn: 'error',
            status: 'error'
        });
    }

    public async loadDatasets() {
        this.loading = true;
        try {
            let result: any = await this.service.request.post('/api/datasets/list');
            if (result.code !== 200) {
                await this.showError(
                    result.data && result.data.message
                        ? result.data.message
                        : '데이터셋을 불러오지 못했습니다.'
                );
                return;
            }
            this.datasets = result.data.datasets || [];
            let current = this.service.auth.session.current_dataset || {};
            if (!this.selectedId || !this.datasets.some((item: any) => item.id === this.selectedId)) {
                this.selectedId = current.dataset_id || (this.datasets.length ? this.datasets[0].id : '');
            }
            this.datasetPage = Math.min(this.datasetPage, this.datasetPageCount());
            if (this.showMemberPanel) await this.loadAccounts();
        } finally {
            this.loading = false;
        }
    }

    public async openCreateDialog() {
        let current = this.selectedDataset();
        this.newDataset = this.emptyDataset(current ? current.organization_id : '');
        this.createStep = 1;
        this.sourceMode = 'FOLDER';
        this.sourceQuery = '';
        this.sourcePage = 1;
        this.selectedDocumentTotal = 0;
        this.selectedUnavailableTotal = 0;
        this.showCreateDialog = true;
        await this.loadSourceOrganizations();
    }

    public closeCreateDialog() {
        if (this.creating) return;
        this.showCreateDialog = false;
    }

    public previousCreateStep() {
        if (this.createStep === 1) {
            this.closeCreateDialog();
            return;
        }
        this.createStep = 1;
    }

    public async goToSourceStep() {
        if (!this.newDataset.name || this.newDataset.name.trim().length < 2) {
            await this.showError('데이터셋 이름을 2자 이상 입력해 주세요.');
            return;
        }
        if (!this.newDataset.organization_id) {
            await this.showError('데이터셋을 만들 기관을 선택해 주세요.');
            return;
        }
        this.createStep = 2;
        if (this.catalogOrganizationId !== this.newDataset.organization_id) {
            await this.loadSourceCatalog();
        }
    }

    public async loadSourceOrganizations() {
        this.sourceLoading = true;
        try {
            let result: any = await this.service.request.post(
                '/api/sources/catalog/organizations',
                { organization_id: this.newDataset.organization_id }
            );
            if (result.code !== 200) {
                await this.showError(
                    result.data && result.data.message
                        ? result.data.message
                        : '원천 기관 정보를 불러오지 못했습니다.'
                );
                return;
            }
            this.sourceOrganizations = result.data.organizations || [];
            let selected = result.data.selected_organization || {};
            this.newDataset.organization_id = selected.id || '';
        } finally {
            this.sourceLoading = false;
        }
    }

    public async loadSourceCatalog() {
        this.sourceLoading = true;
        try {
            let result: any = await this.service.request.post('/api/sources/catalog', {
                organization_id: this.newDataset.organization_id
            });
            if (result.code !== 200) {
                await this.showError(
                    result.data && result.data.message
                        ? result.data.message
                        : '원천자료를 불러오지 못했습니다.'
                );
                return;
            }
            this.sourceOrganizations = result.data.organizations || [];
            let selected = result.data.selected_organization || {};
            this.newDataset.organization_id = selected.id || '';
            this.catalogOrganizationId = this.newDataset.organization_id;
            this.sourceFolders = result.data.folders || [];
            this.sourceAssets = result.data.assets || [];
            this.folderById = {};
            this.sourceFolders.forEach((folder: any) => {
                this.folderById[folder.id] = folder;
            });
            this.updateSourceResults();
            this.recalculateSelectionSummary();
        } finally {
            this.sourceLoading = false;
        }
    }

    public async changeSourceOrganization(organizationId: string) {
        this.newDataset.organization_id = organizationId;
        this.newDataset.source_folder_ids = [];
        this.newDataset.source_asset_ids = [];
        this.catalogOrganizationId = '';
        this.sourceFolders = [];
        this.sourceAssets = [];
        this.sourceFolderResults = [];
        this.sourceAssetResults = [];
        this.folderById = {};
        this.sourceQuery = '';
        this.sourcePage = 1;
        this.recalculateSelectionSummary();
        if (this.createStep === 2) await this.loadSourceCatalog();
    }

    public changeSourceMode(mode: string) {
        this.sourceMode = mode;
        this.sourcePage = 1;
        this.updateSourceResults();
    }

    public updateSourceResults() {
        let query = this.normalizeSearch(this.sourceQuery);
        this.sourceFolderResults = this.sourceFolders.filter((folder: any) => {
            return !query || this.normalizeSearch(folder.path).indexOf(query) >= 0;
        });
        this.sourceAssetResults = this.sourceAssets.filter((asset: any) => {
            return !query || this.normalizeSearch(
                [asset.title, asset.folder_path].join(' ')
            ).indexOf(query) >= 0;
        });
        this.sourcePage = 1;
    }

    public visibleSourceFolders() {
        let start = (this.sourcePage - 1) * this.sourcePageSize;
        return this.sourceFolderResults.slice(start, start + this.sourcePageSize);
    }

    public visibleSourceAssets() {
        let start = (this.sourcePage - 1) * this.sourcePageSize;
        return this.sourceAssetResults.slice(start, start + this.sourcePageSize);
    }

    public sourceResultTotal() {
        return this.sourceMode === 'FOLDER'
            ? this.sourceFolderResults.length
            : this.sourceAssetResults.length;
    }

    public sourcePageCount() {
        return Math.max(1, Math.ceil(this.sourceResultTotal() / this.sourcePageSize));
    }

    public sourceResultStart() {
        return this.sourceResultTotal()
            ? (this.sourcePage - 1) * this.sourcePageSize + 1
            : 0;
    }

    public sourceResultEnd() {
        return Math.min(this.sourcePage * this.sourcePageSize, this.sourceResultTotal());
    }

    public changeSourcePage(direction: number) {
        this.sourcePage = Math.max(
            1,
            Math.min(this.sourcePageCount(), this.sourcePage + direction)
        );
    }

    public folderSelected(folderId: string) {
        return this.newDataset.source_folder_ids.indexOf(folderId) >= 0;
    }

    public async toggleFolder(folderId: string) {
        let folder = this.folderById[folderId];
        if (folder && folder.document_count !== folder.ready_count) {
            await this.showError(
                '이 폴더에는 OCR 또는 사용 확인이 완료되지 않은 문서가 있습니다. 준비 완료 후 선택해 주세요.'
            );
            return;
        }
        let selected = this.newDataset.source_folder_ids;
        let index = selected.indexOf(folderId);
        if (index >= 0) selected.splice(index, 1);
        else selected.push(folderId);
        this.recalculateSelectionSummary();
    }

    public assetSelected(assetId: string) {
        return this.newDataset.source_asset_ids.indexOf(assetId) >= 0;
    }

    public async toggleAsset(assetId: string) {
        let asset = this.sourceAssets.find((item: any) => item.id === assetId);
        if (asset && !asset.ready) {
            await this.showError('OCR 또는 사용 확인이 완료된 문서만 선택할 수 있습니다.');
            return;
        }
        let selected = this.newDataset.source_asset_ids;
        let index = selected.indexOf(assetId);
        if (index >= 0) selected.splice(index, 1);
        else selected.push(assetId);
        this.recalculateSelectionSummary();
    }

    private assetCoveredByFolder(asset: any) {
        let folderId = asset.folder_id;
        let visited: any = {};
        while (folderId && !visited[folderId]) {
            if (this.folderSelected(folderId)) return true;
            visited[folderId] = true;
            let folder = this.folderById[folderId];
            folderId = folder ? folder.parent_id : '';
        }
        return false;
    }

    private recalculateSelectionSummary() {
        let selected = this.sourceAssets.filter((asset: any) => {
            return this.assetSelected(asset.id) || this.assetCoveredByFolder(asset);
        });
        this.selectedDocumentTotal = selected.length;
        this.selectedUnavailableTotal = selected.filter((asset: any) => !asset.ready).length;
    }

    public selectedDocumentCount() {
        return this.selectedDocumentTotal;
    }

    public selectedUnavailableCount() {
        return this.selectedUnavailableTotal;
    }

    public clearSourceSelection() {
        this.newDataset.source_folder_ids = [];
        this.newDataset.source_asset_ids = [];
        this.recalculateSelectionSummary();
    }

    public async choose(dataset: any) {
        if (!dataset || !dataset.id) return;
        let result: any = await this.service.request.post('/api/datasets/select', {
            dataset_id: dataset.id
        });
        if (result.code !== 200) {
            await this.showError(
                result.data && result.data.message
                    ? result.data.message
                    : '데이터셋 선택에 실패했습니다.'
            );
            return;
        }
        this.selectedId = dataset.id;
        this.showMemberPanel = false;
        this.accounts = [];
        this.service.auth.session.current_dataset = result.data.access.current_dataset;
        this.service.auth.session.dataset_roles = result.data.access.dataset_roles;
    }

    public async createDataset() {
        if (this.creating) return;
        if (!this.newDataset.name || this.newDataset.name.trim().length < 2) {
            await this.showError('데이터셋 이름을 2자 이상 입력해 주세요.');
            return;
        }
        if (!this.newDataset.organization_id) {
            await this.showError('데이터셋을 만들 기관을 선택해 주세요.');
            return;
        }
        if (!this.newDataset.source_folder_ids.length && !this.newDataset.source_asset_ids.length) {
            await this.showError('QA 데이터셋으로 만들 폴더 또는 문서를 선택해 주세요.');
            return;
        }
        if (this.selectedUnavailableCount()) {
            await this.showError('선택 범위에 OCR 또는 사용 확인이 필요한 문서가 있습니다.');
            return;
        }
        this.creating = true;
        try {
            let result: any = await this.service.request.post('/api/datasets/create', {
                name: this.newDataset.name,
                description: this.newDataset.description,
                organization_id: this.newDataset.organization_id,
                source_folder_ids: this.newDataset.source_folder_ids.join(','),
                source_asset_ids: this.newDataset.source_asset_ids.join(',')
            });
            if (result.code !== 201) {
                await this.showError(
                    result.data && result.data.message
                        ? result.data.message
                        : '데이터셋 생성에 실패했습니다.'
                );
                return;
            }
            let createdId = result.data.dataset.id;
            this.selectedId = createdId;
            this.showCreateDialog = false;
            await this.loadDatasets();
            let created = this.datasets.find((item: any) => item.id === createdId);
            if (created) await this.choose(created);
        } finally {
            this.creating = false;
        }
    }

    public async toggleMemberPanel() {
        this.showMemberPanel = !this.showMemberPanel;
        if (this.showMemberPanel) await this.loadAccounts();
    }

    public async loadAccounts() {
        this.accounts = [];
        if (!this.selectedId || !this.canManage()) return;
        let result: any = await this.service.request.post('/api/datasets/accounts', {
            dataset_id: this.selectedId
        });
        if (result.code !== 200) {
            await this.showError(
                result.data && result.data.message
                    ? result.data.message
                    : '참여자 정보를 불러오지 못했습니다.'
            );
            return;
        }
        this.accounts = (result.data.accounts || []).map((account: any) => {
            account.roles = (account.roles || []).slice();
            account.processing = false;
            return account;
        });
    }

    public async saveRoles(account: any) {
        if (account.processing) return;
        if (!(account.roles || []).length) {
            await this.showError('하나 이상의 역할을 선택해 주세요.');
            return;
        }
        account.processing = true;
        try {
            let result: any = await this.service.request.post('/api/datasets/assign', {
                dataset_id: this.selectedId,
                user_id: account.id,
                roles: account.roles.join(',')
            });
            if (result.code !== 200) {
                await this.showError(
                    result.data && result.data.message
                        ? result.data.message
                        : '역할 저장에 실패했습니다.'
                );
                return;
            }
            account.assigned = true;
        } finally {
            account.processing = false;
        }
    }

    public async removeMember(account: any) {
        let confirmed = await this.service.modal.show({
            title: '데이터셋 참여 해제',
            message: account.name + ' 사용자의 현재 데이터셋 접근을 해제하시겠습니까?',
            cancel: '취소',
            action: '해제',
            actionBtn: 'error',
            status: 'error'
        });
        if (!confirmed) return;
        let result: any = await this.service.request.post('/api/datasets/remove', {
            dataset_id: this.selectedId,
            user_id: account.id
        });
        if (result.code !== 200) {
            await this.showError(
                result.data && result.data.message
                    ? result.data.message
                    : '참여 해제에 실패했습니다.'
            );
            return;
        }
        account.roles = [];
        account.assigned = false;
    }
}

export default PageAuthoringDatasetsComponent;